import { useField } from 'formik';
import classNames from 'classnames';

interface IProps {
  id?: string;
  htmlFor?: string;
  name: string;
  label?: string;
  focused?: boolean;
  labelClassNames?: string;
}

export const FormFieldLabel = ({ name, label, focused, labelClassNames, id, htmlFor }: IProps) => {
  const [field, _meta, _helpers] = useField(name);

  const className = classNames(
    'field_label',
    {
      field_label_floating: (field.value !== undefined && field.value !== '' && field.value !== null) || focused,
    },
    labelClassNames
  );

  if (!label) {
    return null;
  }

  return (
    <label
      id={id}
      htmlFor={htmlFor}
      className={className}
    >
      {label}
    </label>
  );
};
